import { render, staticRenderFns } from "./clients-products-master-edit.vue?vue&type=template&id=c85da9e2&scoped=true&"
import script from "./clients-products-master-edit.vue?vue&type=script&lang=js&"
export * from "./clients-products-master-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85da9e2",
  null
  
)

export default component.exports